// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid .spin-row {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}
.container-fluid .ant-row .ant-col .ant-card {
  height: 200px !important;
  border-radius: 15px !important;
  margin-bottom: 50px;
}
.container-fluid .ant-row .ant-col .ant-card .ant-card-body {
  padding: 0;
  border-radius: 15px !important;
  outline: none;
  overflow: hidden;
}
.container-fluid .ant-row .ant-col .ant-card .ant-card-body .ant-image {
  height: 200px !important;
}
.container-fluid .ant-row .ant-col .ant-card .ant-card-body .icon-center .icon-center-delete {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
}
.container-fluid .ant-row .ant-col .ant-card .ant-card-body .icon-center .icon-center-checkbox {
  position: absolute;
  top: 10px;
  left: 10px;
  border-radius: 50%;
  width: 20px;
  background: var(--subscribe);
  border: none;
}
.container-fluid .ant-row .ant-col .ant-card .ant-card-body .icon-center .icon-center-checkbox .ant-checkbox-input {
  width: 50%;
}
.container-fluid .ant-row .ant-col .ant-card:hover .icon-center .icon-center-delete {
  display: block;
}
.container-fluid .ant-row .ant-col .images {
  width: 260px !important;
  height: 200px;
}
.container-fluid .ant-row .ant-col .card-active {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/gallery-languages.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAKM;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;AAHR;AAKQ;EACE,UAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;AAHV;AAKU;EACE,wBAAA;AAHZ;AAOY;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AALd;AAQY;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;AANd;AAQc;EACE,UAAA;AANhB;AAcY;EACE,cAAA;AAZd;AAkBM;EACE,uBAAA;EACA,aAAA;AAhBR;AAmBM;EACE,uCAAA;AAjBR","sourcesContent":[".container-fluid {\n  .spin-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 80vh;\n  }\n\n  .ant-row {\n    .ant-col {\n      .ant-card {\n        height: 200px !important;\n        border-radius: 15px !important;\n        margin-bottom: 50px;\n\n        .ant-card-body {\n          padding: 0;\n          border-radius: 15px !important;\n          outline: none;\n          overflow: hidden;\n\n          .ant-image {\n            height: 200px !important;\n          }\n\n          .icon-center {\n            .icon-center-delete {\n              display: none;\n              position: absolute;\n              top: 10px;\n              right: 10px;\n            }\n\n            .icon-center-checkbox {\n              position: absolute;\n              top: 10px;\n              left: 10px;\n              border-radius: 50%;\n              width: 20px;\n              background: var(--subscribe);\n              border: none;\n\n              .ant-checkbox-input {\n                width: 50%;\n              }\n            }\n          }\n        }\n\n        &:hover {\n          .icon-center {\n            .icon-center-delete {\n              display: block;\n            }\n          }\n        }\n      }\n\n      .images {\n        width: 260px !important;\n        height: 200px;\n      }\n\n      .card-active {\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
